import { NgModule } from '@angular/core';
import { NgxCardNumberTemplate, NgxCardNameTemplate, NgxCardExpiryTemplate, NgxCardCvcTemplate } from './inputs';
import { NgxCard } from './card';
import * as ɵngcc0 from '@angular/core';
var CARD_DIRECTIVES = [
    NgxCard,
    NgxCardNumberTemplate,
    NgxCardNameTemplate,
    NgxCardExpiryTemplate,
    NgxCardCvcTemplate,
];
var CardModule = (function () {
    function CardModule() {
    }
CardModule.ɵfac = function CardModule_Factory(t) { return new (t || CardModule)(); };
CardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardModule });
CardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardModule, [{
        type: NgModule,
        args: [{
                declarations: [CARD_DIRECTIVES],
                exports: [CARD_DIRECTIVES]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardModule, { declarations: [NgxCard,
        NgxCardNumberTemplate,
        NgxCardNameTemplate,
        NgxCardExpiryTemplate,
        NgxCardCvcTemplate], exports: [NgxCard,
        NgxCardNumberTemplate,
        NgxCardNameTemplate,
        NgxCardExpiryTemplate,
        NgxCardCvcTemplate] }); })();
    return CardModule;
}());
export { CardModule };
/** @nocollapse */
CardModule.ctorParameters = function () { return []; };

export {NgxCard} from './card';
export {NgxCardNumberTemplate} from './inputs';
export {NgxCardNameTemplate} from './inputs';
export {NgxCardExpiryTemplate} from './inputs';
export {NgxCardCvcTemplate} from './inputs';
